import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const AnnualTax = ({ annualTaxUrl }: SpecProps<"annual_tax_url">) => {
  const { i18n } = useLingui();

  if (!annualTaxUrl) {
    return null;
  }
  const field = i18n._({
    id: "itemPageLayout.keyInfo.yearlyFee",
    message: "Yearly fee",
    comment: "Field for 'yearly fee' in ad specification",
  });

  const link = {
    href: annualTaxUrl,
    text: i18n._({
      id: "itemPageLayout.keyInfo.yearlyFee.readMore",
      message: "Read more",
      comment: "Link to yearly fee info",
    }),
  };

  return <FieldValuePair field={field} link={link} />;
};
